<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------
import { toRaw, watchEffect } from 'vue';

// -------------------------------
// 🔹 Imports composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';
import BaseCheckBox from '../common/BaseCheckBox.vue';

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------
import { useProductStore } from '@/store/product.store';

// -------------------------------
// 🔹 Imports utilitaires
// -------------------------------

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  errorMessage,
  file,
  form_product_step_one,
  previewUrl,
  arraysStepOne,
  category_product,
  stepOneActive,
  stepTwoActive,
  descriptionPageProduct,
  isUpdatedProduct,
  isNewProduct,
  dynamicExtraOptions,
} from '@/refs/product.refs';
import { IconUploadCloud } from '@/assets/svg/common.svg';
import { useCategoryStore } from '@/store/category.store';

// -------------------------------
// 🔹 Imports Types
// -------------------------------

// -------------------------------
// 🔹 Props et emits instanciés
// -------------------------------

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const productStore = useProductStore();
const categoryStore = useCategoryStore();

// -------------------------------
// 🔹 Récupération des commandes avec Vue Query
// -------------------------------

// -------------------------------
// 🔹 Toutes les fonctions
// -------------------------------

// -------------------------------
// 🔹 Debugging (optionnel)
// -------------------------------
// watchEffect(() => {
//     console.log("Valeurs cochées :", productStore.datagetProduct);
// });

const HandleCheckedDesignation = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'firstField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};

const HandleCheckedPrice = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'secondField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};

const HandleCheckedTaxe = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'thirdField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};
const resizeImageTo500 = (file: File): Promise<File> => {
  return new Promise((resolve) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target?.result as string;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;

      canvas.width = 500;
      canvas.height = 500;

      ctx.clearRect(0, 0, 500, 500);
      ctx.drawImage(img, 0, 0, 500, 500);

      canvas.toBlob((blob) => {
        const newFile = new File([blob!], file.name, {
          type: 'image/png',
        });
        resolve(newFile);
      }, 'image/png');
    };

    reader.readAsDataURL(file);
  });
};

const handleFileChange = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const selected = target.files?.[0];
  const title = 'forthField';
  errorMessage.value = null;

  const index = arraysStepOne.value.findIndex((item) => item.title === title);
  if (!selected) {
    if (index !== -1) arraysStepOne.value.splice(index, 1);
    return;
  }
  const allowedTypes = ['image/png', 'image/jpeg'];

  if (!allowedTypes.includes(selected.type)) {
    errorMessage.value =
      'Format non supporté. Formats acceptés : PNG, JPG, JPEG.';
    if (index !== -1) arraysStepOne.value.splice(index, 1);
    return;
  }
  if (selected.size > 5 * 1024 * 1024) {
    errorMessage.value = 'La taille du fichier ne doit pas dépasser 5 Mo.';
    if (index !== -1) arraysStepOne.value.splice(index, 1);
    return;
  }
  const resizedFile = await resizeImageTo500(selected);
  previewUrl.value = URL.createObjectURL(resizedFile);
  file.value = resizedFile;
  const newItem = { value: 1, title };

  if (index !== -1) {
    arraysStepOne.value[index] = newItem;
  } else {
    arraysStepOne.value.push(newItem);
  }

  console.log('📋 Tableau actuel :', arraysStepOne.value);
};

const handleCheckDescription = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'sixthField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};
const handleDelete = () => {
  const title = 'forthField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);
  arraysStepOne.value.splice(index, 1);
  previewUrl.value = null;
};
const goToNextPage = () => {
  if (isUpdatedProduct.value) {
    stepOneActive.value = false;
    isNewProduct.value = false;
    isUpdatedProduct.value = false;
  } else {
    descriptionPageProduct.value =
      'Produit / Nouveau produit / Informations du produit / Ajouter des accompagnements';
    stepOneActive.value = false;
    stepTwoActive.value = true;
  }
};
const handleSubmit = () => {
  if (isUpdatedProduct.value) {
    if (dynamicExtraOptions.value.length === 0) {
      dynamicExtraOptions.value = [
        {
          designation: '',
          price: '',
          taxe: '',
          image: '',
          categorie: '',
          description: '',
          nameExtra: '',
          typeQty: '',
          valueQty: null,
          conditionExtra: '',
          required: false,
          extraOptions: [
            {
              name: '',
              price: '',
            },
          ],
        },
      ];
    }
    console.log(dynamicExtraOptions.value);
    stepOneActive.value = false;
    stepTwoActive.value = true;
  } else {
    goToNextPage();
  }
};
const handleCategoryChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const title = 'fithField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (target.checked) {
    if (index === -1) arraysStepOne.value.push({ value: 1, title });
  } else {
    if (index !== -1) arraysStepOne.value.splice(index, 1);
  }
};

watchEffect(() => {
  //   category_product.value.push("c334f346-c2c3-4a2e-916a-f4cd660e3c1b");
  console.log(toRaw(category_product.value));
});
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-[24px]"
  >
    <div class="space-y-[16px]">
      <div class="flex w-full flex-row gap-4">
        <div class="flex-1 space-y-8">
          <TextInput
            @HandleTextInput="(e: Event) => HandleCheckedDesignation(e)"
            required="true"
            v-model="form_product_step_one.designation"
            name="Nom du produit"
            placeholder="Nom du produit"
            type="text"
            id="Nom du produit"
            label="Nom du produit"
          />
          <div class="flex w-full flex-row items-center justify-between gap-4">
            <TextInput
              @HandleTextInput="(e: Event) => HandleCheckedPrice(e)"
              class="flex-1"
              required="true"
              v-model="form_product_step_one.price"
              name="Prix du produit"
              placeholder="Prix du produit"
              type="text"
              id="Prix du produit"
              label="Prix du produit"
            />
          </div>
        </div>

        <div class="mx-auto flex w-full max-w-sm flex-col items-center gap-4">
          <div
            v-if="!previewUrl"
            class="border-border-input hover:bg-fond-beige flex w-full cursor-pointer flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed bg-white px-[52px] py-[29px] text-center transition"
          >
            <div
              v-html="IconUploadCloud"
              class="flex items-center justify-center"
            />
            <div
              class="text-14px text-secondary-text font-tt-normal-Normal space-y-1 leading-[19px]"
            >
              <p>Format : <span class="font-medium">PNG,JPEG,JPG</span></p>
              <p>Taille max : <span class="font-medium">5 Mo</span></p>
              <p>Résolution : <span class="font-medium">500 × 500 px</span></p>
            </div>

            <label
              for="file-upload"
              class="font-tt-medium-Normal text-selection text-decoration-skip-ink text-14px cursor-pointer text-center underline transition"
            >
              Charger un fichier
            </label>
            <input
              required
              id="file-upload"
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              class="hidden"
              @change="handleFileChange"
            />
          </div>

          <div
            v-else
            class="border-border-input relative h-48 w-full overflow-hidden rounded-2xl border border-dashed bg-white shadow-md"
          >
            <img
              :src="previewUrl"
              alt="Preview"
              class="aspect-square h-full w-full object-contain"
            />
            <button
              @click="handleDelete"
              class="bg-bg-decroissance text-12px text-decroissance absolute top-2 right-2 cursor-pointer rounded px-2 py-1 hover:bg-red-600 hover:text-white"
            >
              Supprimer
            </button>
          </div>

          <p v-if="errorMessage" class="text-center text-sm text-red-600">
            {{ errorMessage }}
          </p>
        </div>
      </div>

      <div>
        <div class="flex w-full flex-row items-center justify-between">
          <h1 class="text-grand-text font-tt-medium-Normal text-14px leading-6">
            Associer à une catégorie
          </h1>

          <!-- <p
            class="text-14px text-selection underline cursor-pointer leading-normal font-tt-medium-Normal"
          >
            Voir plus
          </p> -->
        </div>
        <div class="flex flex-row flex-wrap items-center gap-2">
          <div
            class="border-border-input p-inline-16px my-4 h-[106px] w-[271px] rounded-2xl border border-solid"
            v-for="(item, index) in categoryStore.datagetCategory?.data"
            :key="index"
          >
            <div class="flex flex-row items-start gap-2">
              <BaseCheckBox
                v-model="category_product"
                :id="item.id"
                :value="item.id"
                type="checkbox"
                @change="handleCategoryChange"
              />

              <div class="relative -top-[3px] w-full">
                <p>{{ item.designation }}</p>
                <p
                  class="text-secondary-text font-tt-normal-Normal text-14px line-clamp-2 overflow-hidden text-ellipsis"
                >
                  {{ item.description }}

                  {{
                    item.description === ''
                      ? 'Cette catégorie est vide pour l’instant. Ajoutez une description pour la compléter'
                      : item.description
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h1 class="text-grand-text font-tt-medium-Normal text-14px leading-6">
          Description
        </h1>

        <div class="flex h-auto w-full flex-col items-start">
          <div class="lgShadow !m-0 w-full">
            <textarea
              v-model="form_product_step_one.description"
              @input="(e: Event) => handleCheckDescription(e)"
              class="inputeTextArea text-secondary-text text-littleSize text-text-secondary focus-within:border-text-primary box-border h-[100px] bg-white focus-within:outline-none"
              type="text"
              placeholder="Tape ici..."
              maxlength="315"
            />
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <label
          for="commerce"
          class="text-14px font-tt-medium-Normal leading-normal"
        >
          Veuillez sélectionner un type de produit
          <span class="text-decroissance text-14px leading-normal">*</span>
        </label>

        <select
          required
          id="commerce"
          name="commerce_associé"
          v-model="form_product_step_one.type"
          class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
        >
          <option value="null" disabled>
            Veuillez sélectionner un type de produit
          </option>

          <!-- Exemple de valeurs (à remplacer par ta liste dynamique) -->
          <option value="extra">
            En selectionnant ce type, le produit sera considéré comme un extra
            (accompagnement, supplément, etc.) à ajouter aux produits
            principaux.
          </option>
          <option value="food">
            En selectionnant ce type, le produit sera considéré comme un produit
            qui peut être commandé seul (plat principal, boisson, dessert,
            etc.).
          </option>
          <option value="food&extra">
            En selectionnant ce type, le produit pourra être commandé seul ou
            comme un extra (accompagnement, supplément, etc.).
          </option>
        </select>
      </div>
    </div>

    <div class="flex flex-row items-end justify-end gap-4">
      <div @submit.prevent="goToNextPage">
        <BaseButtonPrimary
          type="submit"
          :label="
            isUpdatedProduct ? 'Annuler la modification' : 'Oublier cette étape'
          "
          style_of_btn="secondary_color_of_btn "
          class="text-grand-text"
        />
      </div>
      <BaseButtonPrimary
        v-model="form_product_step_one.typeExtra"
        type="submit"
        label="Sauvegarder et continuer"
        style_of_btn="primary_color_of_btn "
        class="text-white"
      />
    </div>
  </form>
</template>
